import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';

export default function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        textAlign: 'center',
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        flexShrink: 0
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Want to get your own site?{' '}
        <Link
          href="https://www.sproutcoapp.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            fontWeight: 600,
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          Try SproutCo
        </Link>
      </Typography>
    </Box>
  );
}
